import { style } from '@/styles/globals';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Tabs, Typography } from '@mui/material';
import { Box, styled } from '@mui/system';
import { pr } from '@/utils/pxToRem';

const CustomTabs = styled(Tabs)`
  .MuiTabs-flexContainer {
    flex-wrap: wrap;
  }
`;
const TransportationTabs = ({ title, onBackClick }: { title: string, onBackClick: () => void }) => (
  <div>
    <CustomTabs
      value={false}
      variant="fullWidth"
      onChange={() => { }}
      aria-label="transportation tabs"
    >
      <Box style={{
        margin: '1em 0',
        width: '100%',
        flexBasis: '100%',
      }}
      >
        <ArrowBackIcon
          style={{
            position: 'absolute',
            marginLeft: pr`8px`,
            color: style.color.black1,
            fontSize: '1.8em',
          }}
          onClick={onBackClick}
        />
        <Typography
          variant="body1"
          fontWeight="bold"
          sx={{
            width: '100%',
            textAlign: 'center',
            color: style.color.black1,
          }}
        >
          {title}
        </Typography>
      </Box>
    </CustomTabs>
  </div>
);

export default TransportationTabs;
